import $ from "jquery";

$(document).ready(function ($) {
  $(".menu-toggle").click(function () {
    $(this).toggleClass("is-active");
    $(".site-header .site-menu .main-navigation #menu-primary-menu").slideToggle();
  });

  $(".site-header .site-branding .site-branding-inner .right-part .search-icon").click(function () {
    $(".site-header .form-wrapper form").slideToggle();
  });

  var current_size = $(window).width();
  var current_screen = "";
  if (current_size > 1023) {
    current_screen = "desk";
    // alert(current_screen );
  } else if (current_size > 767 && current_size < 1024) {
    current_screen = "tablet";
  } else {
    current_screen = "mobile";
  }

  function screenChange() {
    var new_size = $(window).width();
    var new_screen = "";
    if (new_size > 1023) {
      new_screen = "desk";
    } else if (new_size > 767 && new_size < 1024) {
      new_screen = "tablet";
    } else {
      new_screen = "mobile";
    }
    if (new_screen == current_screen) {
      return false;
    } else {
      current_screen = new_screen;
      current_size = new_size;
      return true;
    }
  }

  if (current_size < 1023) {
    //sub menu control
    $(".site-header .site-menu .main-navigation #menu-primary-menu > li").click(function () {
      // event.preventDefault();
      $(this).toggleClass("sub-menu-active");
      $(this).find(".sub-menu").slideToggle();
    });
  }

  //homepage slick control

  // var homeBanner = $('');
  var unitsListing = $(".ql-slick");
  var newsuniListing = $(".news-outer-wrapper");
  var eventslick = $(".events-block .event-outer");
  var unitsListingArgs = {
    // dots: true,
    arrows: true,
    infinite: true,
    speed: 600,
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
    // autoplay:true
  };
  var eventlistArgs = {
    centerMode: true,
    centerPadding: "100px",
    slidesToShow: 5,
    // slidesToScroll:5,
    responsive: [
      {
        breakpoint: 1300,
        settings: {
          centerPadding: "100px",
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 1080,
        settings: {
          centerPadding: "60px",
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 767,
        settings: {
          // centerMode: true,
          centerPadding: "50px",
          slidesToShow: 1,
        },
      },
    ],
  };

  if (current_size < 768) {
    if (unitsListing.length > 0) {
      unitsListing.slick(unitsListingArgs);
    }
    // if(newsuniListing.length > 0){
    // 	newsuniListing.slick(unitsListingArgs);
    // }
  }

  if (eventslick.length > 0) {
    eventslick.slick(eventlistArgs);
  }

  if (newsuniListing.length > 0) {
    newsuniListing.slick(unitsListingArgs);
  }

  $(window).resize(function () {
    if (screenChange()) {
      $(".event-outer .slick-list .slick-track .event-item .item-mask").removeClass("not-active");
      if (current_screen == "desk") {
        $(".site-header .site-menu .main-navigation #menu-primary-menu").show();
        if ($(".home-wrapper .quick-link-block .qlb-inner").hasClass("slick-initialized")) {
          unitsListing.slick("unslick"); //destroy slick
        }
        // if ($('.home-wrapper .latest-news-block .news-outer-wrapper').hasClass('slick-initialized')) {
        // 	newsuniListing.slick('unslick'); //destroy slick
        // }
      } else if (current_screen == "tablet") {
        $(".site-header .site-menu .main-navigation #menu-primary-menu").hide();
        $(".site-header .site-menu .menu-toggle").removeClass("is-active");
        $(".site-header .site-menu .main-navigation #menu-primary-menu > li .sub-menu").hide();
        if ($(".home-wrapper .quick-link-block .qlb-inner").hasClass("slick-initialized")) {
          unitsListing.slick("unslick"); //destroy slick
        }
        // if ($('.home-wrapper .latest-news-block .news-outer-wrapper').hasClass('slick-initialized')) {
        // 	newsuniListing.slick('unslick'); //destroy slick
        // }
        //sub menu control
        $(".site-header .site-menu .main-navigation #menu-primary-menu > li").click(function () {
          // event.preventDefault();
          $(this).toggleClass("sub-menu-active");
          $(this).find(".sub-menu").slideToggle();
        });
      } else if (current_screen == "mobile") {
        unitsListing.slick(unitsListingArgs);
        //newsuniListing.slick(unitsListingArgs);
        //sub menu control
        $(".site-header .site-menu .main-navigation #menu-primary-menu > li").click(function () {
          // event.preventDefault();
          $(this).toggleClass("sub-menu-active");
          $(this).find(".sub-menu").slideToggle();
        });
      }
    }
  });

  var bannerCarouselWrapper = $(".home-wrapper .home-banner-outer");
  if (bannerCarouselWrapper.length > 0 && !bannerCarouselWrapper.hasClass("is-video")) {
    bannerCarouselWrapper.slick({
      dots: true,
      infinite: true,
      speed: 1200,
      fade: true,
      //cssEase: 'linear',
      //centerPadding: '0px',
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 10000,
    });
  }

  //slick control end

  //split the first word of event date
  $(".home-wrapper .events-block .event-outer .event-item .date span").html(function () {
    var text = $(this).text().split(" ");
    var first = text.shift();
    return (text.length > 0 ? '<span class="first">' + first + "</span> " : first) + text.join(" ");
  });

  eventslick.on("afterChange", function () {
    $(this)
      .find(".slick-slide")
      .each(function () {
        if ($(this).hasClass("slick-active")) {
          $(this).find(".item-mask").removeClass("not-active");
        } else {
          $(this).find(".item-mask").addClass("not-active");
        }
      });
  });

  if (current_size > 1300) {
    $(".event-outer .slick-next").trigger("click");
    setTimeout(function () {
      $(".event-outer .slick-next").trigger("click");
    }, 500);
  }

  $(".back-to-top").click(function () {
    $("html, body").animate(
      {
        scrollTop: 0,
      },
      500
    );
  });

  $(".latest-news-block .news-outer-wrapper .news-item .news-title").matchHeight();
  $(".news .news-entry-content .news-wrapper .news-inner .news-item .content-area .news-title").matchHeight();
});
